import { createStore } from 'reusable';
import { useEffect, useRef, useState } from 'react';

export const MOBILE_WIDTH = 480;
const isMobileWidth = () => window.innerWidth <= MOBILE_WIDTH;

export const useMobile = createStore(() => {
  const initialIsMobile = isMobileWidth();
  const [isMobile, setIsMobile] = useState(initialIsMobile);
  const isMobileRef = useRef(initialIsMobile);
  useEffect(() => {
    const handleResize = () => {
      if (isMobileRef.current && !isMobileWidth()) {
        setIsMobile(false);
        isMobileRef.current = false;
      } else if (!isMobileRef.current && isMobileWidth()) {
        setIsMobile(true);
        isMobileRef.current = true;
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return { isMobile };
});
